import { styled, Box } from "@mui/material"

export const OpportunityDashboardContainer = styled(Box)({
  flex: 1,
  position: "relative",
  width: "100%",
  height: "90vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
})
